import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Input from "../../../../common/Input";
import {Badge, Spinner} from "react-bootstrap";
import axios from "axios";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";

const ConsumablesModal = ({show, setShow, consumableCategory, handleAdd}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [filter, setFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [consumables, setConsumables] = useState([]);

    useEffect(() => {
        if (show) {
            fetchConsumables();
        }
    }, [])

    const fetchConsumables = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/consumables`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                filter: filter,
                consumableCategory: consumableCategory,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setConsumables(res.data.data);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Εισαγωγή Αναλωσήμων</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{display: "flex", gap: "10px"}} onKeyDown={(e) => {
                        if (e.key === "Enter") fetchConsumables();
                    }}>
                        <div style={{ flex: "6" }}>
                            <Input
                                name={"filter"}
                                unlabbled={true}
                                value={filter}
                                placeholder={"Αναζήτηση αναλωσίμων"}
                                onChange={(e) => setFilter(e.target.value)}
                            />
                        </div>
                        <Button style={{ flex: "4" }} size={"sm"} disabled={loading} onClick={() => fetchConsumables()}>
                            Αναζήτηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </div>
                    {consumables.length > 0 && (
                        <table className={"simpleClassicTable mt-2"}>
                            <colgroup>
                                <col span={1} style={{width: "15%"}}></col>
                                <col span={1} style={{width: "60%"}}></col>
                                <col span={1} style={{width: "15%"}}></col>
                                <col span={1} style={{width: "10%"}}></col>
                            </colgroup>
                            <thead>
                            <tr>
                                <th>Κωδικός</th>
                                <th>Περιγραφή</th>
                                <th>Τιμή Αποζημίωσης</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {consumables.map((cons, idx) => (
                                <tr key={`cons-${idx}`}>
                                    <td>{cons.code}</td>
                                    <td>{cons.description}</td>
                                    <td>{cons.referencePrice}</td>
                                    <td>
                                        <Badge bg={"success"} title={"Προσθήκη"} style={{padding: "6px", paddingTop: "2px", paddingBottom: "2px", cursor: "pointer", fontSize: "20px"}}
                                               onClick={() => handleAdd(cons)}>+</Badge>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default ConsumablesModal
